export function TgSkeleton({
  height = 14,
  width = "100%",
  radius = 6,
}: {
  height?: number;
  width?: string | number;
  radius?: number;
}) {
  return (
    <div
      style={{
        height,
        width,
        borderRadius: radius,
        background:
          "linear-gradient(90deg, var(--color-surface) 25%, var(--color-surface-muted) 50%, var(--color-surface) 75%)",
        backgroundSize: "200% 100%",
        animation: "tg-shimmer 1.5s infinite",
      }}
    />
  );
}

export function ProductCardSkeleton() {
  return (
    <div
      style={{
        background: "#fff",
        border: "1px solid var(--color-border)",
        borderRadius: 10,
        padding: 6,
        display: "flex",
        flexDirection: "column",
        gap: 5,
      }}
    >
      <div
        style={{
          aspectRatio: "1",
          borderRadius: 8,
          background:
            "linear-gradient(90deg, var(--color-surface) 25%, var(--color-surface-muted) 50%, var(--color-surface) 75%)",
          backgroundSize: "200% 100%",
          animation: "tg-shimmer 1.5s infinite",
        }}
      />
      <TgSkeleton height={13} width="85%" />
      <TgSkeleton height={16} width="45%" radius={4} />
    </div>
  );
}
